var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',_vm._g({staticClass:"container__bar",style:({
      height: _vm.height * 2 + 'px',
      opacity: _vm.selected ? 1 : 0.5
    })},_vm.listeners),[_c('div',{staticClass:"container__bar__tooltip",style:({
        visibility: _vm.selected ? 'visible' : 'hidden',
        opacity: _vm.selected ? 1 : 0
      })},[_vm._v("\n       \n      "),_c('span',{staticClass:"container__bar__tooltip__text",style:({
          visibility: _vm.selected ? 'visible' : 'hidden',
          opacity: _vm.selected ? 1 : 0
        })},[_vm._v("R$ "+_vm._s(_vm.formatNumber(_vm.value)))])])]),_c('div',{staticClass:"container__label"},[_vm._v("\n    "+_vm._s(_vm.formatDate(_vm.date))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }